import { render } from "./viewUserRole.vue?vue&type=template&id=14d56b3a&scoped=true"
import script from "./viewUserRole.vue?vue&type=script&lang=js"
export * from "./viewUserRole.vue?vue&type=script&lang=js"

import "./viewUserRole.vue?vue&type=style&index=0&id=14d56b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d56b3a"]])

export default __exports__